import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }

import ServiceList from "@/components/ServiceList.vue"; // NOSONAR

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceArtist',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ServiceList, {
        editable: true,
        url: '/api/service/all'
      })
    ])
  ]))
}
}

})